import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { watchEntireCollection } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { switchMap } from 'rxjs';
import { Category } from '../entities/category.js';
import { ProductFilter } from '../entities/products.js';

export const subscribeAllCategoriesForInstitution = registerSubscription({
  operationName: 'subscribeAllCategoriesForInstitution',
  type: () => [Category],
  params: [
    { name: 'institutionID', type: () => String },
    { name: 'productFilter', type: () => ProductFilter },
  ],
  resolve: (institutionID: string, productFilter?: ProductFilter) => {
    return (gqlFields: BaseQLSelectionSet<Category>) => {
      return watchEntireCollection(Category._collectionName).pipe(
        switchMap(async () => {
          const categoryCollection = await getCollection(Category._class);
          return categoryCollection.find({ institutionID }).toArray();
        }),
      );
    };
  },
});
